/**
 * Search instrumentation helpers
 *
 * Centralizes logging for comparisons and responses search inputs.
 */

import { logger } from '../../../lib/logging';

export function logComparisonSearch(query: string): void {
  const startTime = performance.now();

  logger.info('cmp_search_set', undefined, {
    op: 'cmp_search_set',
    component: 'search',
    view: 'comparisons',
    value: query,
    duration_ms: performance.now() - startTime,
  });
}

export function logResponseSearch(query: string): void {
  const startTime = performance.now();

  logger.info('resp_search_set', undefined, {
    op: 'resp_search_set',
    component: 'search',
    view: 'responses',
    value: query,
    duration_ms: performance.now() - startTime,
  });
}
